import { callPostApi } from "@/api/api";

export const getChannelName = function () {
console.log("getChannelName=====", window.location.host)
    return window.location.origin
}

export const getTranslationByChannelName = function () {
    console.log("getTranslationByChannelName=====", window.location.host)
        switch (window.location.host) {
            case 'juechenjsq.co':			
                return 'translation_jc'; 
            case 'localhost:8081':
                return 'translation_jc';
            case 'test.juechenjsq.com': 
                return 'translation_360'; 
            case 'jc.lsdzty.cn': 
                return 'translation_tf3';
            case 'www.juechenjsq.me': 
                return 'translation_tf15'; 
            case 'juechenjsq.me': 
                return 'translation_tf15'; 
            default:
                return "translation_jc";
        }
    }

export const getChannelNameScriptSRC = async function () {
    console.log("getChannelName=====", window.location.host)
    const body = {
        host: window.location.origin
    }
    const res = await callPostApi('/channel','post',JSON.stringify(body),'','en')
        if(res.isSuccess && res.data) {
            return res.data.script
        }
        return 'https://hm.baidu.com/hm.js?409ebfab297253911dd4e884fd30c396'
    }
